import type {LoggerInfo} from 'src/utils/logger';


const levelMap = {
  warning: 'warn',
  critical: 'error',
} as const;

export default function log(info: LoggerInfo, infoString: string) {
  let {level} = info;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly warning: "warn"; readonly critical: "error"; }'.
  level = levelMap[level] ?? level;

  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Console'.
  console[level](process.env.EX_ENV === 'server' ? infoString : info);
}
